let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("joqnM")).then(() => parcelRequire('deJm0'));